import dynamic from 'next/dynamic';
const CardImageLink = dynamic(() => import('./CardImageLink'));

export default CardImageLink;
